






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "name",
          "sort-desc": false,
        },
        content: {
          name: "Partners",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              name: {
                attrs: {
                  label: "Name",
                },
                rules: {
                  match: {},
                },
              },
              userId: {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  required: true,
                  "item-value": "_id",
                  "item-text": "email",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "email",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                              {
                                key: "role",
                                operator: "equal_to",
                                value: "cpoGroup",
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          displayFields: {
            name: {
              text: "Name",
              sortable: true,
            },
            user: {
              text: "User",
              options: {
                subProp: "user.email",
                label: true,
                sortBy: "userId",
              },
            },
            disabled: {
              text: "Status",
              options: {
                boolean: true,
                label: (value: boolean) => {
                  return value ? "Disabled" : "Active";
                },
                attrs(value) {
                  return {
                    color: value ? "error" : "success",
                  };
                },
              },
            },
            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["systemAdmin", "admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("cpoGroups", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("cpoGroups", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "cpoGroups",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("cpoGroups", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Name",
                  required: true,
                },
              },
              userId: {
                type: "XAutocomplete",
                attrs: {
                  label: "User",
                  required: true,
                  "item-value": "_id",
                  "item-text": (item) => `${item.email}${item.phone ? ' (' + item.phone + ')' : ''}`,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const filters = [
                          {
                            key: "_id",
                            operator: "equal_to",
                            value,
                          },
                          {
                            key: "role",
                            operator: "equal_to",
                            value: "cpoGroup",
                          },
                        ];
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "email",
                            orderType: "asc",
                            filters,
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              disabled: {
                type: "boolean",
                attrs: {
                  label: "Disabled",
                },
                ext: {
                  defaultValue: false,
                },
              },
            },
            insertForm: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                fieldNames: ["name", "userId", "disabled"],
              },
            },
            editForm: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                fieldNames: ["name", "userId", "disabled"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
